import Button from 'components/_UI/Button'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints';
import { PlusSquare } from 'lucide-react';
import Text from 'components/_UI/Text';
import colors from 'theme/colors';
import usePanelPermissions from 'hooks/usePanelPermissions';
import { PERMISSIONS } from 'helpers/panelPermissions';

export default function RightSlotProducts({ setIsCreate }) {
    const { can } = usePanelPermissions();

    if (!can(PERMISSIONS.PRODUCTS_MANAGE)) return null;

    return (
        <RightSlotContainer>
            <ButtonContainer>
                <Button
                    marginBottom='0'
                    variant='featured'
                    category='squiredBorded'
                    onClick={() => setIsCreate(true)}
                >
                    <PlusSquare color={colors.neutralLight} size={18} />
                    <Text color={colors.neutralLight} marginLeft={'6px'} paddingBottom={0}>
                        Adicionar produto
                    </Text>
                </Button>
            </ButtonContainer>
        </RightSlotContainer>
    )
}

const RightSlotContainer = styled.div`
    width: 100%;
    height: 100%;

    & > button {
        margin-bottom: 0 !important;
    }

    @media screen and (min-width: ${breakpoints.md}){
        width: auto;
    }

`;

const ButtonContainer = styled.div`
    width: 100%;
    & > button {
            height: 35px;
            padding: 0;
    }
    @media screen and (min-width: ${breakpoints.md}){
        width: 165px;
        height: 100%;
        & > button {
            height: 35px;
            padding: 0;
        }
    }
    @media screen and (min-width: ${breakpoints.lg}){
        & > button {
            height: 35px;
        }
    }
    @media screen and (min-width: ${breakpoints.xl}){
        & > button {
            height: 35px;
        }
        margin-right: 0;
    }
`;